import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'functionName',
    header: 'Function/Type',
    type: 'text',
    width: 50,
  },
  {
    key: 'employeesRequired',
    header: 'Employees Required',
    type: 'number',
    placeholder: 'Not Provided',
  },
  {
    key: 'numberToHire',
    header: 'Number to Hire',
    type: 'number',
    placeholder: 'Not Provided',
  },
  {
    key: 'hiringLeadTime',
    header: 'Hiring Lead Time (months)',
    type: 'number',
    placeholder: 'Not Provided',
  },
  {
    key: 'qualificationRequired',
    header: 'Qualifications/Requirements',
    placeholder: 'Not Provided',
    type: 'text',
    width: 50,
  },
];
